import { ImageStoreTablePage } from 'widgets/imagesStore';

const ImageStore = () => (<ImageStoreTablePage />);

export default ImageStore;
